import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { DQOIErrorBus } from '@app/cp/shared/models/DQOIError';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'dispatch-errors',
    templateUrl: './dispatch-errors.component.html',
    styleUrls: ['./dispatch-errors.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DispatchErrorsComponent extends BaseGridEditLineComponent<DQOIErrorBus, null, DispatchesService>  {
    dispErrCatFC: MSFilterClass = new MSFilterClass('categoryId');
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "DQOIErrorBus";
        this.appCode = "DispatchErrors";
        //necessary for grid displays that dont search
        this.disableCpSearchDialog();
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'errorId': new UntypedFormControl(),
            'categoryId': new UntypedFormControl(),
            'referenceId': new UntypedFormControl(),
            'categoryName': new UntypedFormControl(), 
            'categoryDescription': new UntypedFormControl(), 
            'comments': new UntypedFormControl(), 
            'userName': new UntypedFormControl(), 
            'whoEnteredName': new UntypedFormControl(), 
            'personId': new UntypedFormControl(), 
            'insertUserId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            errorId: this.selectedData.errorId,
            categoryId: this.selectedData.categoryId,
            referenceId: this.selectedData.referenceId,
            categoryName: this.selectedData.categoryName,
            categoryDescription: this.selectedData.categoryDescription,
            comments: this.selectedData.comments,
            userName: this.selectedData.userName,
            whoEnteredName: this.selectedData.whoEnteredName,
            personId: this.selectedData.personId,
            insertUserId: this.selectedData.insertUserId,
            insertDt: this.selectedData.insertDt
        });
    }
    setFromReferenceData(data: DQOIErrorBus) {
        data.userName = this.personName(data.personId);
        data.whoEnteredName = this.personFromUserId(data.insertUserId).description;
        //data.categoryDescription = this.referenceData.getDispErrCat(data.categoryId);
        return data;
    }

    getChangedObject(data: DQOIErrorBus) {
        let busObj: DQOIErrorBus = new DQOIErrorBus(data);
        busObj.setBeforeSave();
        return busObj;
    }
    save(data: DQOIErrorBus) {
        let busObj: DQOIErrorBus = this.getChangedObject(data);        
        this.svc_data.saveError(busObj).subscribe((dataObj: BaseMessageInfo) => {
            
            if (!dataObj.saveError) {
                let dataObj2: DQOIErrorBus = new DQOIErrorBus(dataObj.primaryReturn);
                this.saveSuccess(dataObj2);
            }
            else {
                this.saveError(dataObj.primaryReturn as DQOIErrorBus, dataObj.message);
            }
        });
    }
    deleteIndividual(data: DQOIErrorBus) {
        if (data.hasId) {
            this.svc_data.deleteError(data.errorId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }
}
